export default "__VITE_ASSET__BudCRAil__"